// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__X0_Vk","loading-roller":"styles_loading-roller__Rxh6K"};